export default "__VITE_ASSET__B5hHYM0s__"